import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownProductExtraServiceCategories', request)
}

export {get}
